
import axios, { AxiosError, AxiosInstance } from 'axios';
import ErrorResponse from './../../../src/error-response';

import * as ServerData from './../../server-data';

export default class MasterReaderService {

   public static lookupCreditor(
           axiosInstance: AxiosInstance, input: ServerData.MasterWebReader.LookupCreditor$Input,
           f: (output: ServerData.SpineData$FreedCreditor[]) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'spineapi/master/lookup-creditor',
            {params : input.toJson()}
        ).then((response) => (response.data as object[]).map((x) => ServerData.SpineData$FreedCreditor.fromJson(x)))
       .then((output) => f(output))
       .catch(theEh);
   }


   public static getServiceableCreditorList(
           axiosInstance: AxiosInstance, input: ServerData.MasterWebReader.GetServiceableCreditorList$Input,
           f: (output: ServerData.SpineData$FreedCreditor[]) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'spineapi/master/get-serviceable-creditor-list',
            {params : input.toJson()}
        ).then((response) => (response.data as object[]).map((x) => ServerData.SpineData$FreedCreditor.fromJson(x)))
       .then((output) => f(output))
       .catch(theEh);
   }


   public static getOffers(
           axiosInstance: AxiosInstance, input: ServerData.MasterWebReader.GetOffers$Input,
           f: (output: ServerData.SpineData$Offers) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'spineapi/master/get-offers',
            {params : input.toJson()}
        ).then((response) => ServerData.SpineData$Offers.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


   public static getStateList(
           axiosInstance: AxiosInstance, input: ServerData.MasterWebReader.GetStateList$Input,
           f: (output: ServerData.MasterWebReader.GetStateList$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'spineapi/master/get-state-list',
            {params : input.toJson()}
        ).then((response) => ServerData.MasterWebReader.GetStateList$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


   public static getNupayBankMasterList(
           axiosInstance: AxiosInstance, input: ServerData.MasterWebReader.GetNupayBankMasterList$Input,
           f: (output: ServerData.MasterWebReader.GetNupayBankMasterList$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'spineapi/master/get-nupay-bank-master-list',
            {params : input.toJson()}
        ).then((response) => ServerData.MasterWebReader.GetNupayBankMasterList$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


   public static getClientLanguageList(
           axiosInstance: AxiosInstance, input: ServerData.MasterWebReader.GetClientLanguageList$Input,
           f: (output: string[]) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'spineapi/master/get-client-language-list',
            {params : input.toJson()}
        ).then((response) => response.data as string[])
       .then((output) => f(output))
       .catch(theEh);
   }


   public static getPaymentPlanDetails(
           axiosInstance: AxiosInstance, input: ServerData.MasterWebReader.GetPaymentPlanDetails$Input,
           f: (output: ServerData.PPData$PaymentPlanDetails) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'spineapi/master/get-payment-plan-details',
            {params : input.toJson()}
        ).then((response) => ServerData.PPData$PaymentPlanDetails.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


}

